import { BaseContainerService } from './containers/services/base-container-service';
import { ListData } from './../base-models/list-data';
import { BaseDataService } from './../base-services/base-data.service';
import { ModelData } from './../base-models/model-data';
import { BaseEntity } from './../base-models/base-entity';
import { Input, OnInit, Output, EventEmitter } from '@angular/core';
import { QueryParameter } from '../base-models/query-parameter';
import { Subscription } from 'rxjs';
import { RefreshType } from '../base-models/refresh-type';
import { List } from 'immutable';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../base-services/modal.service';
// import { NotificationsService } from 'angular2-notifications';
// import { ConfirmationDialogButtons } from '../../public_api';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { NotificationService } from '../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';

export class BaseDetailListComponent<T extends BaseEntity> implements OnInit {
    // constructor(
        
    //     protected baseDataService: BaseDataService,
    //     protected containerService: BaseContainerService<T>,
    //     protected translateService: TranslateService,
    //     protected modalService: ModalService,
    //     protected notificationsService: NotificationsService
    // )
    //     {
            
    //     }
    
        constructor(
        
            protected baseDataService: BaseDataService,
            protected containerService: BaseContainerService<T>,
            protected translateService: TranslateService,
            protected modalService: ModalService,
            protected toastrService: NotificationService
        )
            {
                
            }

    _model: ListData;
    protected _parentPropertyName: string;
    protected _parentPropertyValue: number;
    private _emittedItemSubscription: Subscription;

    items: List<T>;
    
    @Input() set Model(value: ListData){
        this._model = value;
    }

    @Input() set ParentPropertyName(value: string){
        this._parentPropertyName = value;
    }

    @Input() set ParentPropertyValue(value: number){
        this._parentPropertyValue = value;
        if(value && value > 0){
        this.loadItems(this._model.ModelName, this._model.GetName, this.getQueryParameter(), this._model.ShortModelClass)
            .subscribe((data: T[]) => {
                this.items = List(data);
                this.Items.emit(this.items);
            })
        }
        else{
            this.items = List([]);
            this.Items.emit(this.items);
        }
    }

    @Input() Parameters: QueryParameter[];

    @Output() Items = new EventEmitter<List<T>>();

    ngOnInit(){
        this._emittedItemSubscription = this.containerService.EmittedItem
            .subscribe((item: T) => {
                this.processEmittedItem(item);
            })
    }

    private loadItems<T extends BaseEntity>(modelName: string, getName: string, parameters: QueryParameter[], modelClass: any){
        return this.baseDataService.Get<T>(modelName, getName, parameters, modelClass);
    }

    private getQueryParameter(): QueryParameter[]{
        let queryParameters: QueryParameter[] = [];
        let queryParameter = new QueryParameter();
        queryParameter.Name = this._parentPropertyName;
        queryParameter.Value = this._parentPropertyValue;
        queryParameters.push(queryParameter);
        return queryParameters;
    }

    private processEmittedItem(item: T){
        if(this._model.RefreshType == RefreshType.NoReload){
            let index = this.getItemIndex(item.ID, this.items);
            if(index == -1 && item[this._model.DefaultPropertyName] != null)
                this.items = this.addItem(item, this.items);
            else if(index > -1 && item[this._model.DefaultPropertyName] != null)
                this.updateItem(item, this.items, index);
            this.Items.emit(this.items);
        }
        else {
            this.loadItems(this._model.ModelName, this._model.GetName, this.getQueryParameter(), this._model.ShortModelClass)
                .subscribe((data: T[]) => {
                    this.items = List(data);
                    this.Items.emit(this.items);
                })
        }
    }

    private getItemIndex(id: number, list: List<T>){
        let itemIndex: number = -1;
        list.forEach((item, index) => {
            if(item.ID == id)
                itemIndex = index;
        })
        return itemIndex;
    }

    private addItem(item: T, list: List<T>){
        if(!list)
            list = List([]);
        list = list.push(item);
        return list;
    }

    private updateItem(item: T, list: List<T>, index: number){
        //list[index] = item;
        item.Selected = true;
        this.items = this.items.set(this.getItemIndex(item.ID, this.items), item);
    }

    DeleteItem(ID: T){
        this.translateService.get(['FW.ACTION.DELETE.ACTIONNAME', 'FW.ACTION.DELETE.MESSAGE.SUCCESS', 'FW.ACTION.DELETE.QUESTION'])
            .subscribe(translate => {
                    this.modalService.ShowConfirmationDialog(
                                translate["FW.ACTION.DELETE.ACTIONNAME"], 
                                translate["FW.ACTION.DELETE.QUESTION"] + ID[this._model.DefaultPropertyName] + '?',
                                'question'
                                )
                        .result
                            .then((result) => {
                                if(result){
                                    this.baseDataService.Delete(this._model.ModelName, ID.ID)
                                        .subscribe(data => {
                                            this.OnItemDelete(data);
                                            // this.notificationsService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], ID[this._model.DefaultPropertyName]);
                                            this.toastrService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], ID[this._model.DefaultPropertyName]);
                                            // if(this.mainItems.size > 0) this.SelectMainItem(this.mainItems[0])
                                            // else this.detailItems = null;
                                        })
                                }
                            }, (reason) => {
                                
                            })
                    //}
            })
    }

    DeleteItems(){
        if(this.items.find(item => item.Checked == true) == null) {
            this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Odaberite stavke.",
                "alert",
                ConfirmationDialogButtons.Ok
              );
            return;
        }
        this.items.forEach(item => {
            if(item.Checked)
                this.DeleteItem(item);
        })
    }

    // DeleteItem(ID: T){
    //     if(confirm('Da li ste sigurni da želite da obrišete?')){
    //         this.baseDataService.Delete(this._model.ModelName, ID.ID)
    //             .subscribe(data => {
    //                 this.OnItemDelete(data);
    //             })
    //     }
    // }

    OnItemDelete(ID: number){
        this.items = this.items.splice(this.getItemIndex(ID, this.items), 1);
        this.Items.emit(this.items);
    }

    RefreshData(){
        this.loadItems(this._model.ModelName, this._model.GetName, this.getQueryParameter(), this._model.ShortModelClass)
            .subscribe((data: T[]) => {
                this.items = List(data);
                this.Items.emit(this.items);
            })
    }
}